export const BRAND = "F&C Impianti";
export const PHONE_DISPLAY = "06 94806609";
export const PHONE_TEL = "tel:+390694806609";
export const WHATSAPP_URL =
  "https://wa.me/393803660364?text=Buongiorno%2C%20vorrei%20un%20preventivo%20per%20assistenza%20caldaia%2Fcondizionatore.";
export const ROMA_QUARTIERI = [
  "Centro Storico", "Prati", "Borgo", "Trastevere", "Testaccio", "Aventino",
  "San Saba", "Esquilino", "Monti", "Celio", "San Giovanni", "Appio Latino",
  "Tuscolano", "Cinecittà", "Quadraro", "Don Bosco", "Centocelle", "Pigneto",
  "Torpignattara", "San Lorenzo", "Casal Bertone", "Nomentano", "Trieste",
  "Salario", "Parioli", "Villaggio Olimpico", "Flaminio", "Vigna Clara",
  "Fleming", "Corso Francia", "Cassia", "Tomba di Nerone", "Grottarossa",
  "La Giustiniana", "La Storta", "Monte Sacro", "Talenti", "Pietralata",
  "Tiburtino", "Casal Bruciato", "Conca d'Oro", "Bufalotta", "Fidene",
  "Serpentara", "Casal Boccone", "Monte Sacro Alto", "Aurelio", "Val Cannuta",
  "Boccea", "Casalotti", "Selva Candida", "Trionfale", "Balduina",
  "Monte Mario", "Primavalle", "Ottavia", "Colli Portuensi", "Monteverde",
  "Gianicolense", "Portuense", "Magliana", "Corviale", "La Pisana",
  "San Paolo", "Ostiense", "Garbatella", "Marconi", "Tor Marancia",
  "EUR", "Torrino", "Mostacciano", "Spinaceto", "Laurentino", "Cecchignola",
  "Ardeatino", "Appio Pignatelli", "Ostia", "Acilia", "Casal Palocco",
  "Infernetto", "Axa", "Dragona", "Vitinia", "Ostia Antica", "Isola Sacra",
  "Fregene",
];

export const ZONES = [
  "Roma (tutti i quartieri e municipi)",
  "Fiumicino",
  "Guidonia Montecelio",
  "Tivoli",
  "Aprilia",
  "Pomezia",
  "Anzio",
  "Nettuno",
  "Velletri",
  "Civitavecchia",
  "Monterotondo",
  "Ciampino",
  "Marino",
  "Frascati",
  "Albano Laziale",
  "Ladispoli",
  "Cerveteri",
  "Ardea",
  "Fonte Nuova",
  "Mentana",
  "Grottaferrata",
  "Zagarolo",
  "Palestrina",
  "Santa Marinella",
  "...e tutti i comuni della provincia",
];

export const BOILER_BRANDS = [
  "Vaillant", "Baxi", "Ariston", "Beretta", "Rinnai", "Bosch", "Junkers",
  "Ferroli", "Riello", "Viessmann", "Immergas", "Saunier Duval", "Hermann",
  "Sime", "Sylber", "Biasi", "Italtherm", "Lamborghini Calor", "Chaffoteaux",
  "Radiant", "Fondital", "Unical", "Cosmogas", "Nova Florida", "Domusa",
  "Arca", "Baltur", "Ecoflam", "Bentone", "Thermital", "Wolf", "Weishaupt",
  "Remeha", "Brötje", "De Dietrich", "Atlantic", "Chappée", "Elm Leblanc",
  "MHG",
];

export const AC_BRANDS = [
  "Daikin", "Mitsubishi Electric", "Samsung", "LG", "Fujitsu General",
  "Panasonic", "Toshiba", "Hitachi", "Gree", "Midea", "Haier",
  "Hisense", "Olimpia Splendid", "De' Longhi", "Clivet", "Aermec",
  "Carrier", "Argoclima",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1660330589693-99889d60181e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxodmFjJTIwdGVjaG5pY2lhbnxlbnwwfHx8fDE3OTE4NDg1NzV8MA&ixlib=rb-4.1.0&q=85",
  caldaia: "https://images.unsplash.com/photo-1594233078955-e1f73a02ebb2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxib2lsZXIlMjByZXBhaXJ8ZW58MHx8fHwxNzkxODQ4NTc1fDA&ixlib=rb-4.1.0&q=85",
  condizionatore: "https://images.unsplash.com/photo-1762341123870-d706f257a12e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxhaXIlMjBjb25kaXRpb25pbmclMjBob21lfGVufDB8fHx8MTc5MTg0ODU3NXww&ixlib=rb-4.1.0&q=85",
  van: "https://images.unsplash.com/photo-1641199788912-9a7385a35c82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHx3b3JrJTIwdmFufGVufDB8fHx8MTc5MTg0ODU3NHww&ixlib=rb-4.1.0&q=85",
  technician: "https://images.unsplash.com/photo-1677938438599-a55528c41b2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHx0ZWNobmljaWFuJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkxODQ4NTc1fDA&ixlib=rb-4.1.0&q=85",
};
